/**
 * JINS Beauty Glasses x Megumi Kanzaki
 * Collaboration Landing Page JavaScript
 */

// Page mask - fade in on load
window.addEventListener("load", () => {
  document.querySelector(".bgkm-page .main_wrap").classList.add("is-show");
});

(function($) {
  $(function() {

    // Fade-in on scroll
    function fadeInCheck() {
      $('.bgkm-page .fadein').each(function() {
        const elemPos = $(this).offset().top;
        const scroll = $(window).scrollTop();
        const windowHeight = $(window).height();

        if (scroll > elemPos - windowHeight + 200) {
          $(this).addClass('show');
        }
      });
    }

    $(window).on('scroll', function() {
      fadeInCheck();
    });

    $(window).on('load', function() {
      fadeInCheck();
    });

    $(window).on('resize', function() {
      fadeInCheck();
    });

    // Smooth scroll for anchor links
    $('.bgkm-page a[href^="#"]').on("click", function() {
      var speed = 600;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'body' : href);
      var position = target.offset().top;
      $('body,html').animate({ scrollTop: position }, speed, 'swing');
      return false;
    });

  });
})(jQuery);

// Styling Slider Data - English Translations
const bgkmStylingData = [
  // 01 - Face-Contouring Frames
  {
    title: `Elevate casual style with <br class="sp">face-contouring frames`,
    itemHtml: `
      <div class="slider_item_wrap">
        <p class="_item">LRF-25A-214 94</p>
        <img src="https://cdn.shopify.com/s/files/1/0562/8903/4283/files/bgkm_slide_item_01.png">
        <p class="_name">Face-Contouring Frames</p>
      </div>
    `,
    text: `
      Pairing an oversized sweatshirt with a feminine, natural-toned lip and bold, thick glasses elevates the look, keeping it effortless without feeling too casual. Thick  frames with a carefully considered shape add a modern touch to the oversized silhouette.
    `,
    link: "https://us.jins.com/products/jins-x-kanzaki-megumi-214-94",
  },
  // 02 - Eye-Defining Frames
  {
    title: `Define your gaze with <br class="sp">bold browline frames`,
    itemHtml: `
      <div class="slider_item_wrap">
        <p class="_item">LMF-25A-213 87</p>
        <img src="https://cdn.shopify.com/s/files/1/0562/8903/4283/files/bgkm_slide_item_02.png">
        <p class="_name">Eye-Defining Frames</p>
      </div>
    `,
    text: `
      Browline glasses that draw focus to the eyes add strength around the face, holding their own against a masculine jacket. With metal along the bottom of the frame, they blend easily with any outfit while delivering an effortless and sophisticated look.
    `,
    link: "https://us.jins.com/products/jins-x-kanzaki-megumi-213",
  },
  // 03 - Glow-Enhancing Frames
  {
    title: `Lightweight metal frames that <br class="sp">enhance your natural radiance`,
    itemHtml: `
      <div class="slider_item_wrap">
        <p class="_item">LTF-25A-212 96</p>
        <img src="https://cdn.shopify.com/s/files/1/0562/8903/4283/files/bgkm_slide_item_03.png">
        <p class="_name">Glow-Enhancing Frames</p>
      </div>
    `,
    text: `
      Metal-frame glasses lend a sheer, innocent air, acting as the perfect counterbalance to a pattern-on-pattern look. The rounded shape softens the overall impression, adding a touch of mature sweetness and understated charm to the style.
    `,
    link: "https://us.jins.com/products/jins-x-kanzaki-megumi-212-96",
  },
  // 04 - Feature-Enhancing Frames
  {
    title: `Tapered frames that accentuate <br class="sp">your natural structure`,
    itemHtml: `
      <div class="slider_item_wrap">
        <p class="_item">LMF-25A-215 81</p>
        <img src="https://cdn.shopify.com/s/files/1/0562/8903/4283/files/bgkm_slide_item_04.png">
        <p class="_name">Feature-Enhancing Frames</p>
      </div>
    `,
    text: `
      Pair a feminine top with tapered-frame glasses that highlight the bone structure to create a look with effortless confidence, polished, yet never predictable. A refined accent around the face elevates a conservative outfit, embodying a new vision of modern femininity.
    `,
    link: "https://us.jins.com/products/jins-x-kanzaki-megumi-215",
  }
];

// Swiper initialization
document.addEventListener('DOMContentLoaded', function() {
  const sliderTtl = document.querySelector('.bgkm-page .slider_ttl');
  const sliderItem = document.querySelector('.bgkm-page .slider_item');
  const sliderText = document.querySelector('.bgkm-page .slider_item_text');

  // Check if elements exist before initializing
  if (!sliderTtl || !sliderItem || !sliderText) {
    console.log('Slider elements not found');
    return;
  }

  function updateContent(index) {
    const data = bgkmStylingData[index];

    sliderTtl.innerHTML = data.title;
    sliderItem.innerHTML = data.itemHtml;
    sliderText.querySelector('._text').innerHTML = data.text;
    sliderText.querySelector('a').href = data.link;
  }

  const swiper = new Swiper('.bgkm-page .styling_slider_wrap .swiper', {
    slidesPerView: 3,
    centeredSlides: true,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.bgkm-page .styling_slider_wrap .swiper-button-next',
      prevEl: '.bgkm-page .styling_slider_wrap .swiper-button-prev',
    },

    on: {
      init() {
        updateContent(this.realIndex);
      },

      slideChangeTransitionStart() {
        sliderTtl.classList.add('is-hide');
        sliderItem.classList.add('is-hide');
        sliderText.classList.add('is-hide');
      },

      slideChangeTransitionEnd() {
        updateContent(this.realIndex);

        requestAnimationFrame(() => {
          sliderTtl.classList.remove('is-hide');
          sliderItem.classList.remove('is-hide');
          sliderText.classList.remove('is-hide');
        });
      }
    }
  });
});
